import type { PropsWithChildren } from 'react';
import type React from 'react';

import { PetitionStatsContext } from './context';
import { useApiPetitionStats } from './useApiPetitionStats';

type Props = Readonly<{
	slug: string;
}>;

export const PetitionStatsContextProvider: React.FC<PropsWithChildren<Props>> = ({ slug, children }) => {
	const petitionStatsState = useApiPetitionStats(slug);

	return <PetitionStatsContext.Provider value={petitionStatsState}>{children}</PetitionStatsContext.Provider>;
};
